<template>
  <v-app>
    <v-app-bar app color="white" flat height="163" width="100%">
      <v-container fluid>
        <v-row>
          <v-col cols="12">
            <div class="d-flex align-center chsli-logo">
              <v-img
                alt="CHSLI Logo"
                class="shrink mr-2"
                contain
                src="https://www.chsli.org/sites/default/files/2021-04/logo_0.png"
                transition="scale-transition"
                width="382"
                height="97"
              />
              <!-- <h2>CHSoogle</h2> -->
            </div>
            <!-- <v-spacer></v-spacer>
            <span class="mr-2">Data Date: {{ runDateTime }}</span>-->
          </v-col>
        </v-row>
        <v-row style="background-color: #f1ebe5">
          <v-col cols="12">
            <div
              class="d-flex align-center link"
              style="color: black; font-weight: bold; padding-left: 115px"
              @click="goHome"
            >
              HOME
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-app-bar>

    <v-content style="margin-bottom: 15px">
      <keep-alive>
        <router-view />
      </keep-alive>
    </v-content>
    <template>
      <v-footer fixed padless style="background-color: #f1ebe5">
        <v-col class="text-center" cols="12">
          The Catholic Health Physician Partners (Tier 1) Provider Directory was updated on {{ runDateTime }}. If you are enrolled in the Catholic Health Medical Plan, please use this site to search for Catholic Health Physician Partners providers who are considered to be Tier 1. If you or a covered dependent seek care with a Catholic Health Physician Partners provider, you will be covered at 100%. This network is subject to change so please be sure to confirm with the provider at the time of making your appointment that they are in the Catholic Health Physician Partners Network and there will be no copay for the visit. If you have any questions, please call MYHR at 516-705-6947.
        </v-col>
      </v-footer>
    </template></v-app
  >
</template>
  </v-app>
</template>

<script>
export default {
  name: "App",

  data: () => ({}),
  beforeMount() {
    this.$store.dispatch("FETCH_AUTOCOMPLETE_LIST");
    this.$store.dispatch("FETCH_PROVIDER_LIST");
  },
  computed: {
    runDateTime: function () {
      return new Date(this.$store.getters.DATA_DATE).toLocaleString();
    },
  },
  methods: {
    goHome: function () {
      window.open("https://www.chsli.org", "_self");
    },
  },
};
</script>

<style>
.v-toolbar__content {
  padding-left: 0px !important;
  padding-right: 0px !important;
}
.chsli-logo {
  padding-left: 115px;
}
@media only screen and (max-width: 1295px) {
  .chsli-logo {
    padding-left: 0px;
  }
}
</style>
